import * as React from "react";
import { SVGProps } from "react";
const SvgTag = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.343 4c-.802 0-1.555.312-2.12.879L4 18.101 13.9 28l13.221-13.222A2.972 2.972 0 0 0 28 12.657V7c0-1.654-1.345-3-3-3h-5.657ZM13.9 30a1.985 1.985 0 0 1-1.414-.586l-9.9-9.899A1.99 1.99 0 0 1 2 18.099c0-.535.209-1.036.587-1.413L15.808 3.465A4.965 4.965 0 0 1 19.343 2H25c2.757 0 5 2.243 5 5v5.657c0 1.336-.52 2.592-1.465 3.536l-13.22 13.22a1.983 1.983 0 0 1-1.413.587H13.9ZM25.758 8.242a1.995 1.995 0 0 1-2 2 1.996 1.996 0 0 1-2-2 1.995 1.995 0 0 1 2-2c.512 0 1.023.195 1.414.586.391.391.586.902.586 1.414ZM8.243 19.515 6.83 18.1l6.614-6.615 1.414 1.414-6.614 6.615Zm2.829 2.828-1.414-1.414 3.079-3.08 1.413 1.415-3.079 3.079Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTag;
